export default "__VITE_ASSET__BfIRT2wg__"